import type { AbstractControl } from '@angular/forms';

export const minMaxRangeValidator =
  (minFieldName: string, maxFieldName: string) =>
  (control: AbstractControl): { range: boolean } | null => {
    const minControl = control.parent?.get(minFieldName);
    const maxControl = control.parent?.get(maxFieldName);

    const min =
      minControl?.value && Number(formatNumberWithSeparators(minControl.value.toString()));
    const max =
      maxControl?.value && Number(formatNumberWithSeparators(maxControl.value.toString()));

    return Number.isFinite(min) && Number.isFinite(max) && min > max ? { range: true } : null;
  };

const formatNumberWithSeparators = (value: string): string =>
  value
    .replace(',', '.')
    .replace(/[.](?=.*[.])/g, '')
    .replace(/\s/g, '');
